import { Email, Phone } from "@msuite/ui/link";
import { joinJSXElements } from "@msuite/ui/utils";
import { hasNonNull } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface ContactInformationProps {
	contact: Tables<"contacts">;
}

export function ContactInformation({ contact }: ContactInformationProps) {
	/** Guard */
	const hasValues = hasNonNull(contact.email, contact.phone);
	if (!hasValues) return null;

	/** Computed */
	const contactInformation = joinJSXElements(
		[
			contact.email ? <Email key="email">{guardString(contact.email)}</Email> : null,
			contact.phone ? <Phone key="phone">{guardString(contact.phone)}</Phone> : null,
		],
		" ",
	);

	/** Render */
	return <div className="gap-4 h-stack">{contactInformation}</div>;
}
